export default "__VITE_ASSET__9426589c__"